import axios from 'axios';
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getEmployerProfileAndCompany = async (token, id) => {
    try {
        const response = await heyapi.get(`/admin/employer/details?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const updateEmployerProfileAndCompany = async (token, data) => {
    try {
        
        const response = await heyapi.post(`/admin/employer/add?id=new`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        //console.log(response.data)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const uploadLogo = async (collegeid, state, token, reason) => {
}